<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">Import users</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <form [formGroup]="importUserForm">
      <!-- Role Selection -->
      <div class="form-group">
        <label *ngIf="importUserForm.get('role')?.value" class="sub-header-drpdown pb-2"
          >Role *</label
        >
        <ng-select
          [clearable]="false"
          [clearOnBackspace]="false"
          #role
          [items]="roleList$ | async"
          [searchable]="false"
          bindLabel="name"
          bindValue="idStr"
          formControlName="role"
          placeholder="Role *"
          [loading]="!(roleList$ | async)"
        >
          <ng-template ng-header-tmp>
            <div class="has-feedback">
              <input
                type="text"
                class="form-control accordion-search search-input"
                id="inputValidation"
                (input)="role.filter($any($event.target).value)"
                placeholder="Search..."
              />
              <span class="form-control-feedback">
                <i class="fa fa-search icon"></i>
              </span>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
            <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
          </ng-template>
          <ng-template ng-notfound-tmp>
            <div class="custom-notfound">No roles found</div>
          </ng-template>
          <ng-template ng-loadingtext-tmp>
            <div class="custom-loading">Loading roles...</div>
          </ng-template>
        </ng-select>
        <div
          *ngIf="
            importUserForm.controls['role']?.touched && importUserForm.controls['role']?.invalid
          "
          class="input-error"
        >
          Role is required
        </div>
      </div>

      <!-- Excel File Upload -->
      <div class="form-group mt-3">
        <label class="sub-header-drpdown pb-2">Import Excel File *</label>
        <div class="row">
          <div class="col-12">
            <piqet-angular-file-upload
              [type]="'excel'"
              [customConfig]="excelUploadConfig"
              [isDisabled]="isUploading"
              (fileSelected)="onFileSelected($event)"
              (fileRemoved)="onFileRemoved()"
              (removeConfirmation)="onRemoveConfirmation()"
            >
            </piqet-angular-file-upload>
          </div>
        </div>
        <div
          *ngIf="
            importUserForm.controls['excelFile']?.touched &&
            importUserForm.controls['excelFile']?.invalid
          "
          class="input-error"
        >
          Excel file is required
        </div>
      </div>

      <!-- Download Template Link -->
      <div class="form-group mt-2">
        <p class="template-info">
          <i class="fa fa-info-circle mr-1"></i>
          Need a template?
          <a href="javascript:void(0)" (click)="downloadTemplate()" class="template-link">
            Download excel template
          </a>
        </p>
      </div>

      <!-- Things to Keep in Mind -->
      <div class="form-group mt-5">
        <h6 class="things-to-keep-title"><strong>Things to keep in mind:</strong></h6>
        <div class="info-notification-clean">
          <span class="bullet">•</span>
          {{ getLicenseInfoMessage() }}
        </div>
        <div class="info-notification-clean mt-2">
          <span class="bullet">•</span>
          You can import a maximum of &nbsp; <strong>100</strong> &nbsp; users at a time.
        </div>
        <div class="info-notification-clean mt-2">
          <span class="bullet">•</span>
          The default password assigned to all newly created users is &nbsp;<strong
            class="password"
            #defaultPassword
            title="Click to copy password"
            (click)="copyPassword(defaultPassword.innerText)"
            >PIQET2Try!</strong
          >.
        </div>
      </div>

      <!-- Validation Errors Table -->
      <div *ngIf="validationErrors.length > 0" class="mt-3">
        <div class="error-table-container">
          <div class="table-responsive">
            <table class="table table-sm error-table">
              <thead>
                <tr>
                  <th>Row</th>
                  <th>Field</th>
                  <th>Error</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let error of validationErrors">
                  <td>{{ error.row }}</td>
                  <td>{{ error.field }}</td>
                  <td>{{ error.message }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Server Error Alert -->
      <div
        class="alert alert-danger alert-dismissible fade show"
        role="alert"
        *ngIf="serverErrorMessage"
      >
        <i class="fa fa-exclamation-circle me-2"></i>
        {{ serverErrorMessage }}
      </div>
    </form>
  </div>
  <div class="modal-footer extraPadding">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      [disabled]="
        importUserForm.invalid || isUploading || validationErrors.length > 0 || serverErrorMessage
      "
      (click)="onSave()"
    >
      <span *ngIf="!isUploading">Import Users</span>
      <span *ngIf="isUploading"> <i class="fa fa-spinner fa-spin mr-1"></i> Importing... </span>
    </button>
  </div>
</div>
